<template>
  <TheLoader :active="true" v-if="loading"/>
  <div class="content-container flex-row" v-else>
    <section class="content white">
      <TheEmptyList :title="'Ingen abonnement'" :large="true" :icon="'glyph-medium-object'"/>
    </section>
  </div>
</template>

<script>
export default {
  name: 'KundeCardShowTabAbonnement',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      loading: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShowTabAbonnement.vue